module.exports = {"system_events":"Esdeveniments interns del sistema"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/Events.json
// module id = 587
// module chunks = 1